import axios from 'axios'
import isEmpty from 'lodash/isEmpty';
import { getRefreshUrl, getDomain } from '@/helpers/brandHelper.js'
import { getCookieValue } from "@/helpers/index.js";


const SFCORE_ACCESS_KEY = import.meta.env.VITE_SFCORE_ACCESS_KEY

export const keepSessionAlive = async () => {
  try {
    const payload = { 
      "request":{ 
         "requestInfo":{ 
            "service":"SessionAPI",
            "method":"keepAlive",
            "clientId":"NSI",
            "apiAccessKey": SFCORE_ACCESS_KEY
         }
      }
   }
    const data = await axios.post(getRefreshUrl(), payload, { withCredentials: true } );
    
    if (!isEmpty(data)) {
      console.info("Session refreshed successfully");
    }
  } catch (error) {
    console.error("Error refreshing session:", error);
  }
}

export const sfCoreRefreshCall = async () => {
  /*
    This call returns a token inside response.data.response.data.a_token
    However we are not using this token for anything. This call is made just to keep the session alive.
  */

  const pId = getCookieValue("_sp_productInstanceId")
  try {
    const payload = { 
      request: {
        productInstanceId: pId,
        requestInfo: {
          apiAccessKey: 'c7pdpbtzvixa1d0hws5jvbfpmqv',
          clientId: 'SitePlus',
          method: 'getJWTTokenV1',
          service: 'ProductAPI',
        },
      },
    }
    await axios.post(`https://www.${getDomain()}/sfcore.do`, payload, { withCredentials: true } );
   }
   catch (error) {
    console.error("Error refreshing session:", error);
  }
}